"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _excluded = ["children", "className", "element", "fullWidth", "inverted", "disabled", "inferior"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CallToAction = function CallToAction(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'button' : _ref$element,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$inferior = _ref.inferior,
      inferior = _ref$inferior === void 0 ? false : _ref$inferior,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var props = _objectSpread({
    className: (0, _classnames2.default)(_indexModule.default.root, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, _indexModule.default.fullWidth, fullWidth), (0, _defineProperty2.default)(_classnames, _indexModule.default.inverted, inverted), (0, _defineProperty2.default)(_classnames, _indexModule.default.disabled, disabled), (0, _defineProperty2.default)(_classnames, _indexModule.default.inferior, inferior), _classnames)),
    disabled: disabled
  }, restProps);

  return /*#__PURE__*/_react.default.createElement(element, props, children);
};

CallToAction.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  element: _propTypes.default.oneOfType([_propTypes.default.elementType, _propTypes.default.node]),
  fullWidth: _propTypes.default.bool,
  inverted: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  inferior: _propTypes.default.bool
};
var _default = CallToAction;
exports.default = _default;